
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import UserPanel from './views/UserPanel/index.vue'
import ProgressCourse from './views/ProgressCourse/index.vue'
import StudyRecord from './views/StudyRecord/index.vue'
import ContentList from './views/ContentList/index.vue'
import UserContentPop from '@xt/www/components/classhour/pop-content/index.vue'
import type { HomeworkOption, DairyOption } from '@xt/client/entities/course-v2/user-content'
import { Observer } from 'mobx-vue'
import { CommonStudyCardUIData } from '@xt/client/entities/my-v2/types'
import { EnumMyCenterPrivacyConfig } from '@xt/client/enums/my'
import lodash from 'lodash'
import { Route } from 'vue-router'
import { Bind, Debounce } from 'lodash-decorators'

@Observer
@Component({
  scrollToTop: true,
  components: {
    UserPanel,
    ProgressCourse,
    StudyRecord,
    ContentList,
    UserContentPop
  },
  async asyncData(ctx) {
    const isSelfVisit = ctx.store.$storeUser.UserInfo.id === ctx.query.memberId
    const res = await ctx.store.$myV2.Center.initPageData(ctx.query.memberId as string, isSelfVisit)

    if (!res) {
      ctx.redirect('/')
    }
  },
  validate({ query }) {
    const memberId = query.memberId
    return !!memberId && /^\d+$/.test(String(memberId))
  }
})
export default class UserCenterPage extends Vue {
  @Ref()
  userContentPop: {
    showPop: (options: HomeworkOption | DairyOption) => void
    hidePop: () => void
  }

  memberId: string = lodash.get(this.$route, 'query.memberId', '') as string

  get EnumMyCenterPrivacyConfig() {
    return EnumMyCenterPrivacyConfig
  }

  get isSelfVisit() {
    return this.memberId === this.$store.$storeUser.UserInfo.id
  }

  get PageStore() {
    return this.$store.$myV2.Center
  }

  // 此处作品也直接走日常详情类型进行展示, 极少数情况投票中的如果momentId为空, 则不处理
  async handleClickCard(data: CommonStudyCardUIData) {
    switch (data.type) {
      case 'dairy':
        this.userContentPop?.showPop({ type: 'dairy', momentId: `${data.id}` })
        return
      case 'collect':
        if (data.jumpType === 'show' || !data.id) return
        this.userContentPop?.showPop({ type: 'dairy', momentId: `${data.id}` })
        return
    }
  }

  handleLikeInCard(item: CommonStudyCardUIData) {
    this.PageStore.onLike(item)
  }

  // 弹窗外部回显状态处理
  handleFollowInContentPop(data: boolean) {
    this.PageStore.updateFollowData(data)
  }

  handleLikeInContentPop({ momentId }: { momentId: string }) {
    const item = this.PageStore.pagePagination.dataSource.find(i => i.id === momentId)

    if (item) {
      this.PageStore.onChangeLikeStatus(item, 'like')
    }
  }

  handleRemoveInContentPop(data: { type: 'homework'; homeworkId: number } | { type: 'dairy'; momentId: string }) {
    this.PageStore.onRemoveItem(data.type === 'dairy' ? data.momentId : data.homeworkId)

    if (data.type === 'homework') {
      this.userContentPop?.hidePop()
    }
  }

  @Watch('$route', { deep: true })
  onRouteChange(val: Route) {
    location.reload()
  }

  rightStyle: string = ''
  ob1: IntersectionObserver | null = null
  ob2: ResizeObserver | null = null

  @Debounce(300, { leading: true, trailing: true })
  @Bind()
  updateRightStyle(): void {
    const el = document.getElementById('right-content')

    if (!el) return

    const viewHeight = Math.floor(document.body.offsetHeight - 90)

    this.rightStyle = `height: ${el.offsetHeight > viewHeight ? `${viewHeight}px` : 'auto'}`
  }

  @Debounce(300, { leading: true, trailing: true })
  @Bind()
  handleRightScroll(entries: IntersectionObserverEntry[]) {
    const el = document.getElementById('right-content')

    if (!el) return

    el.scrollTo({
      top: entries[0].isIntersecting ? el.offsetHeight : 0,
      behavior: 'smooth'
    })
  }

  initObserver(): void {
    const el1 = document.getElementById('enter-line')
    const el2 = document.body

    if (el1) {
      this.ob1 = new IntersectionObserver(this.handleRightScroll, {
        root: null,
        threshold: [0, 1]
      })
      this.ob1.observe(el1)
    }

    if (el2) {
      this.ob2 = new ResizeObserver(this.updateRightStyle)
      this.ob2.observe(el2)
    }
  }

  uninstallObserver(): void {
    if (this.ob1) {
      this.ob1.disconnect()
      this.ob1 = null
    }
    if (this.ob2) {
      this.ob2.disconnect()
      this.ob1 = null
    }
  }

  created(): void {}

  mounted(): void {
    this.initObserver()
  }

  updated(): void {}

  destroyed(): void {
    this.uninstallObserver()
  }
}
